import { SearchAtoms } from './atoms';

export * from './atoms';

export const SearchComponents = [
    ...SearchAtoms
]